import { Select } from "antd"
import { useEffect} from 'react';
import { SizeType } from "antd/es/config-provider/SizeContext";
import { useSelector } from "react-redux";
import store from "../../../../controllers/store";
import { find } from '../../../../controllers/store/actions/projects/get-project-status-action';
import { PageSetting, Query } from "../../..";

interface Props {
    onChange: (value: string) => void,
    size?: SizeType,
    onClear: () => void
    defaultValue?: string,
    style?: any
}
const dispatch = store.dispatch
const SelectProjectStatus = (props: Props) => {
    const projectStatusState = useSelector((state: any) => state.projectsStatus);
    useEffect(() => {
        dispatch(find(PageSetting.page, PageSetting.limit, {} as Query));
    }, []);

    return (
        <div style={{ width: '100%' }}>
            <Select
                {...props}
                labelInValue
                allowClear
                size={props.size}
                defaultValue={props?.defaultValue || ''}
                style={props.style}
                onChange={(value: any) => {
                    props.onChange(value);
                }}
                options={projectStatusState.list.map((e: any) => ({ label: e.estado, value: e.id }))}
            />
        </div>
    );
}

export default SelectProjectStatus